import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'
import ReportePorCerealView from '../components/ReportePorCerealView'

class ReportePorCereal extends Component {
  componentDidMount () {
    this.props.fetchSectores()
  }

  render () {
    return <ReportePorCerealView />
  }
}

const withRedux = connect(null, actions)

export default withRedux(ReportePorCereal)
